import React from 'react'
import Tabs from './Tabs'

const DestinationToMeetings = () => {
  return (
    <div>
        <Tabs/>
    </div>
  )
}

export default DestinationToMeetings